export default "__VITE_ASSET__CZLv5Y9A__"